import React from "react";

const Address = ({ address }) => {
    return address.map((item, i) =>
        i > 0 ? (
            <small key={i} className="text-muted">
                , {item}
            </small>
        ) : (
            <span key={i}>{item}</span>
        ),
    );
};
export default Address;
